<template>
  <div class="skeleton-chat">
    <!-- 顶部栏骨架 -->
    <div class="skeleton-header">
      <div class="skeleton-back"></div>
      <div class="skeleton-avatar"></div>
      <div class="skeleton-info">
        <div class="skeleton-name"></div>
        <div class="skeleton-status"></div>
      </div>
    </div>

    <!-- 消息列表骨架 -->
    <div class="skeleton-messages">
      <!-- 左侧消息（客服） -->
      <div class="skeleton-message left">
        <div class="skeleton-bubble short"></div>
      </div>

      <!-- 右侧消息（用户） -->
      <div class="skeleton-message right">
        <div class="skeleton-bubble medium"></div>
      </div>

      <!-- 左侧消息 -->
      <div class="skeleton-message left">
        <div class="skeleton-bubble long"></div>
      </div>

      <!-- 右侧消息 -->
      <div class="skeleton-message right">
        <div class="skeleton-bubble short"></div>
      </div>

      <!-- 支付卡片骨架 -->
      <div class="skeleton-message left">
        <div class="skeleton-card">
          <div class="skeleton-card-header"></div>
          <div class="skeleton-card-amount"></div>
          <div class="skeleton-card-button"></div>
        </div>
      </div>
    </div>

    <!-- 输入框骨架 -->
    <div class="skeleton-footer">
      <div class="skeleton-input"></div>
      <div class="skeleton-send-btn"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonChat'
}
</script>

<style scoped>
.skeleton-chat {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
}

/* 顶部栏 */
.skeleton-header {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: #fff;
  border-bottom: 1px solid #eee;
  gap: 12px;
}

.skeleton-back {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.skeleton-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.skeleton-info {
  flex: 1;
}

.skeleton-name {
  width: 120px;
  height: 16px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  margin-bottom: 8px;
}

.skeleton-status {
  width: 60px;
  height: 12px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

/* 消息列表 */
.skeleton-messages {
  flex: 1;
  padding: 16px;
  overflow: hidden;
}

.skeleton-message {
  margin-bottom: 16px;
  display: flex;
}

.skeleton-message.left {
  justify-content: flex-start;
}

.skeleton-message.right {
  justify-content: flex-end;
}

.skeleton-bubble {
  height: 50px;
  border-radius: 12px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.skeleton-bubble.short {
  width: 40%;
}

.skeleton-bubble.medium {
  width: 55%;
}

.skeleton-bubble.long {
  width: 70%;
}

/* 支付卡片骨架 */
.skeleton-card {
  width: 75%;
  padding: 16px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.skeleton-card-header {
  height: 20px;
  width: 80px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  margin-bottom: 12px;
}

.skeleton-card-amount {
  height: 32px;
  width: 120px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  margin-bottom: 12px;
}

.skeleton-card-button {
  height: 36px;
  width: 100%;
  border-radius: 18px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

/* 底部输入框 */
.skeleton-footer {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: #fff;
  border-top: 1px solid #eee;
  gap: 12px;
}

.skeleton-input {
  flex: 1;
  height: 40px;
  border-radius: 20px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.skeleton-send-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

/* 闪烁动画 */
@keyframes shimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}
</style>
